export default __webpack_public_path__ + "static/feature-language-b9d90b09851fe8a7093ff0ef1fbb1650.png";